module.exports = __webpack_public_path__ + "img/progress_036.38c3d834.png";